import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import TextArea from 'ui/TextArea';

/**
 * Компонент-обертка для интеграции компонента TextField с библиотекой react-hook-form.
 * Упрощает использование TextField в формах, управляемых через react-hook-form.
 *
 * @param {string} name - Имя поля в форме (обязательный параметр)
 * @param {string} className - список классов стилей
 * @param {string} label - Видимое название поля пользователю
 * @param {boolean} [required=false] - Флаг указывающий на обязательность заполнения поля
 * @param {boolean} [isFormValidate=false] - Флаг указывающий на обязательность валидации заполнения поля
 * @param {Object} rules - Правила валидации для react-hook-form
 * @param {string} type - Тип поля
 * @param {string} placeholder - Текст для отображения, когда ничего не введено
 * @param {boolean} hideErrorBlock - скрыть блок для ошибки
 **/
export const FormTextArea = ({
  className = '',
  label = '',
  placeholder = '',
  name,
  required = false,
  rules = {},
  hideErrorBlock = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const formRules = useMemo(() => {
    let defaultRules = {};
    if (required) {
      defaultRules.required = 'Поле обязательно для заполнения';
    }

    return { ...defaultRules, ...rules };
  }, [required, rules]);

  return (
    <Controller
      name={name}
      control={control}
      rules={formRules}
      render={({ field: { onChange, value, name } }) => (
        <TextArea
          name={name}
          className={className}
          label={label}
          required={required}
          placeholder={placeholder}
          value={value}
          isFormValidate={!!errors[name]}
          onChange={onChange}
          hideErrorBlock={hideErrorBlock}
          errorMessage={errors[name]}
        />
      )}
    />
  );
};

export default FormTextArea;
